import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {NewPipeline, Pipeline} from '../../services/pipelinesApi.types'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {getPipelineDraftEntry, setPipelineDraftEntry} from './EditPipelinePage.slices.utils'

export const set: CaseReducer<
  PipelineDraftState,
  PayloadAction<{pipeline: Pipeline; branch: string}>
> = (state, action) => {
  const {pipeline, branch} = action.payload
  setPipelineDraftEntry(state, pipeline.id, {draft: pipeline, original: pipeline}, branch)
}

export const setDraftPreservingCollision: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; draft: NewPipeline; branch: string}>
> = (state, action) => {
  const {id, draft, branch} = action.payload
  const existing = getPipelineDraftEntry(state, id, branch)
  if (existing != null) {
    setPipelineDraftEntry(
      state,
      id,
      {
        draft,
        original: existing.original,
        isCollisionApi: existing.isCollisionApi,
      },
      branch,
    )
  }
}

export const updateDraft: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; draft: NewPipeline; branch: string}>
> = (state, action) => {
  const {id, draft, branch} = action.payload
  const existing = getPipelineDraftEntry(state, id, branch)
  if (existing != null) {
    setPipelineDraftEntry(
      state,
      id,
      {
        ...existing,
        draft,
        original: existing.original,
      },
      branch,
    )
  }
}

export const reset: CaseReducer<PipelineDraftState, PayloadAction<{id: string; branch: string}>> = (
  state,
  action,
) => {
  const {id, branch} = action.payload
  const {original} = getPipelineDraftEntry(state, id, branch) ?? {}
  setPipelineDraftEntry(state, id, {original, draft: original}, branch)
}

export const setPipelineName: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; name: string; branch: string}>
> = (state, action) => {
  const {id, name, branch} = action.payload
  const {draft} = getPipelineDraftEntry(state, id, branch) ?? {}
  if (draft != null) {
    draft.name = name
  }
}
